import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  skillsBuilderHeaderTitle: {
    id: 'skills.builder.header.title',
    defaultMessage: 'Skills Builder',
    description: 'Title for the Skills Builder feature',
  },
  skillsBuilderHeaderSubheading: {
    id: 'skills.builder.header.subheading',
    defaultMessage: 'Let edX be your guide',
    description: 'Subheading to the Skills Builder title in the header component',
  },
});

export default messages;
